import React, { useState } from "react";
import axios from "axios";
import { API_DOMAIN } from "config";
import { Img, Heading } from "components";

export default function ProUpgradePage({ currentUser }) {
  const [plan, setPlan] = useState("monthly");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

const startPay = async () => {
  setErr("");
  setLoading(true);
  try {
    const res = await axios.post(`${API_DOMAIN}/billing/createPaymeSale`, {
      user_id: currentUser.id,
      plan,
    });

    const data = res.data;

    if (!data?.success) {
      setErr(data?.error || "נכשל ליצור תשלום");
      return;
    }

    if (!data?.data?.sale_url) {
      setErr("לא חזר sale_url מהשרת");
      return;
    }

const pid = Number(data?.data?.payment_id || 0);
if (!pid) {
  setErr("לא חזר payment_id מהשרת");
  return;
}
window.location.href = `/pro-pay/${pid}?u=${encodeURIComponent(data.data.sale_url)}`;

  } catch (e) {
    setErr(e?.response?.data?.error || "שגיאה בהתחלת תשלום. נסי שוב.");
  } finally {
    setLoading(false);
  }
};


  return (

          <div className="car-catalog-dealer flex bg-blue_gray-50 p-8 sm:p-4 " style={{paddingTop: '1.2rem'}}>
            <div className="w-[100%] items-start gap-4 md:flex-col" style={{ gap: '2%' }}>
              <div className="flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4">
                <header className="flex flex-col items-start gap-3">
                  <div className="absolute top-0 left-0 h-8 w-[20%] bg-[rgb(239,240,241)] flex items-center justify-center gap-4 rounded-br-[10px] md:px-5">
                    <div className="flex w-full justify-center gap-1">
                      <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                        <span className="text-gray-900_04">&nbsp;</span>
                        <span className="font-heebo font-medium text-gray-600">pro</span>
                      </Heading>
                      <Img src="/images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                    </div>
                    <div className="flex w-full items-center justify-center">
                      <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                        שדרוג
                      </Heading>
                      <Img src="/images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                    </div>
                  </div>
                  <div className="flex items-center justify-between gap-5 mt-5 self-stretch border-b border-solid border-gray-200 md:flex-col">
              
                    <div className="flex justify-center gap-4 xs-flex-row-reverse md:flex-row">

                    </div>
                    <div className="flex gap-3">
                      <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                        שדרוג מנוי 🚀                     </Heading>
                    </div>
                  </div>
                </header>
                <div className="tfpro-page">
      <div className="tfpro-shell">
        <div className="tfpro-header">
          <div>
            <div className="tfpro-kicker">שדרוג חשבון</div>
            <div className="tfpro-title">PRO לספקים</div>
            <p className="tfpro-subtitle">עם סליקה מאובטחת של PayMe.</p>
          </div>
        </div>

        <div className="tfpro-grid">
          <div className="tfpro-card">
            <div className="tfpro-row-between">
              <div>
                <div className="tfpro-card-title">בחרי מסלול</div>
                <div className="tfpro-card-desc">אפשר לשנות/להפסיק בכל עת.</div>
              </div>

              <div className="tfpro-toggle">
                <button
                  type="button"
                  className={`tfpro-toggle-btn ${plan === "monthly" ? "is-active" : ""}`}
                  onClick={() => setPlan("monthly")}
                  disabled={loading}
                >
                  חודשי
                </button>
                <button
                  type="button"
                  className={`tfpro-toggle-btn ${plan === "yearly" ? "is-active" : ""}`}
                  onClick={() => setPlan("yearly")}
                  disabled={loading}
                >
                  שנתי <span className="tfpro-chip">חיסכון</span>
                </button>
              </div>
            </div>

<div className="tfpro-price">
  {plan === "yearly" ? "₪1,188" : "₪129"}
</div>
<div className="tfpro-price-sub">
  {/*{plan === "yearly" ? "לשנה • חיוב שנתי" : "לחודש • חיוב חודשי"}*/}
    {plan === "yearly" ? " • חיוב שנתי" : "לחודש"}

</div>


            <button className="tfpro-btn tfpro-btn--primary" onClick={startPay} disabled={loading} type="button">
              {loading ? "מכין תשלום..." : "שדרוג ל-PRO"}
            </button>

            <button className="tfpro-btn tfpro-btn--secondary" type="button" onClick={() => (window.location.href = "/dashboard")}>
              לא עכשיו
            </button>

            {err ? <div className="tfpro-alert tfpro-alert--error">{err}</div> : null}
          </div>

          <div className="tfpro-card">
            <div className="tfpro-card-title">מה מקבלים</div>
            <ul className="tfpro-ul">
              <li className="tfpro-li"><span className="tfpro-check">✓</span><span>יותר חשיפות</span></li>
              <li className="tfpro-li"><span className="tfpro-check">✓</span><span>כלים מתקדמים</span></li>
              <li className="tfpro-li"><span className="tfpro-check">✓</span><span>תג PRO בפרופיל</span></li>
              <li className="tfpro-li"><span className="tfpro-check">✓</span><span>תמיכה בעדיפות</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
              </div>
            </div>
          </div>

  );
}
